import React, { useEffect, useState } from "react";
import useSave from "../../Hooks/useSave";
import useFetch from "../../Hooks/useFetch";
import useDelete from "../../Hooks/useDelete";
import Table from "./../../Components/Table";
import { Link } from "react-router-dom";
import Modal from "react-awesome-modal";
import Api from "../../Hooks/Api";
const ProjectsActivities = (props) => {
  const [open, setOpen] = useState(false);
  const [inputs, setInputs] = useState({});
  const [view, setview] = useState(false);
  const [organizationOptions, setOrganizations] = useState([]);
  const [objectiveOptions, setObjectiveOptions] = useState([]);
  const [healthOptions, setHealthOptions] = useState([]);
  const [update, setUpdate] = useState(false);
  const url = "api/projects";
  const { state, FetchAll } = useFetch(url);
  const [statusOptions, setStatusOptions] = useState([
    { name: "Open" },
    { name: "Active" },
  ]);
  const fetchRegions = async () => {
    try {
      Api.get("/api/organizations")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setOrganizations(data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };
  const fetchHealth = async () => {
    try {
      Api.get("/api/projectHealth")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setHealthOptions(data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };
  const fetchObjectives = async () => {
    try {
      Api.get("/api/objectives")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setObjectiveOptions(data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };
  useEffect(() => {
    FetchAll();
    fetchHealth();
    fetchRegions();
    fetchObjectives();
  }, []);

  const handleOpenModal = (event) => {
    event.persist();
    setInputs({});
    setOpen(true);
  };

  const handleInputChange = (event) => {
    event.persist();
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setInputs((inputs) => ({ ...inputs, [name]: value }));
  };

  const handleEdit = () => {
    if (inputs.projectId) {
      setOpen(true);
      setUpdate(true);
      setview(false);
    } else {
      alert("Select a record to edit");
    }
  };
  const handleView = () => {
    if (inputs.projectId) {
      setview(true);
      setUpdate(false);
      setOpen(true);
    } else {
      alert("Select a record to veiw");
    }
  };
  const handleSelect = (k, event) => {
    setInputs({});
    setInputs(k);
  };
  const handleCloseModal = () => {
    setOpen(false);
    setview(false);
  };

  const HandleSubmit = (event) => {
    event.preventDefault();
    useSave(url, inputs);
  };
  const CallDeletehook = () => {
    useDelete(url + "/delete?id=" + inputs.projectId);
  };
  const HandelDelete = () => {
    if (inputs.projectId) {
      CallDeletehook();
    } else {
      alert("Select a record to delete");
    }
  };
  const ColumnData = [
    {
      label: "Id",
      field: "projectId",
      sort: "asc",
    },
    {
      label: "Organization",
      field: "organization",
      sort: "asc",
    },
    {
      label: "Strategic Objective",
      field: "objective",
      sort: "asc",
    },
    {
      label: "Key Projects and Activitie",
      field: "title",
      sort: "asc",
    },
    {
      label: "Bdget Allocation",
      field: "budgetAllocation",
      sort: "asc",
    },
    {
      label: "Start Date",
      field: "startDate",
      sort: "asc",
    },
    {
      label: "End Date",
      field: "endDate",
      sort: "asc",
    },
    {
      label: "Status",
      field: "status",
      sort: "asc",
    },
    {
      label: "Health",
      field: "health",
      sort: "asc",
    },
  ];
  let Rowdata1 = [];
  const rows = state.data;
  if (rows.length > 0) {
    rows.forEach((k) => {
      const Rowdata = {
        clickEvent: () => handleSelect(k),
        title: k.title,
        projectId: k.projectId,
        organization: k.organization ? k.organization.name : "N/A",
        budgetAllocation: k.budgetAllocation,
        startDate: k.startDate,
        endDate: k.endDate,
        status: k.status,
        health: k.health ? k.health.meaning : "N/A",
        objective: k.objective ? k.objective.title : "N/A",
      };
      Rowdata1.push(Rowdata);
    });
  }
  return (
    <div id="content" className="content">
      <ol class="breadcrumb float-xl-right">
        <li class="breadcrumb-item">
          {" "}
          <Link to="/">Home </Link>{" "}
        </li>
        <li class="breadcrumb-item active">Projects Setup</li>
      </ol>
      <h1 class="page-header mb-3">Projects Setup</h1>
      <div style={{ backgroundColor: "white" }}>
        <div className="row">
          <div class="col-sm-12 d-flex flex-row float-right">
            &nbsp; &nbsp; &nbsp;
            <button
              onClick={handleOpenModal}
              className="btn btn-primary p-2"
              style={{ marginRight: 5, marginTop: 5 }}
            >
              New
            </button>
            <button
              onClick={handleView}
              className="btn btn-success p-2"
              style={{ marginRight: 5, marginTop: 5 }}
            >
              View
            </button>
            <button
              onClick={handleEdit}
              className="btn btn-info p-2"
              style={{ marginRight: 5, marginTop: 5 }}
            >
              Edit
            </button>
            <button
              onClick={HandelDelete}
              className="btn btn-danger p-2"
              style={{ marginRight: 5, marginTop: 5 }}
            >
              Delete
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <Table Rows={Rowdata1} columns={ColumnData} />
          </div>
        </div>
      </div>

      <Modal visible={open} width="60%" height="83%" effect="fadeInUp">
        <div style={{ "overflow-y": "auto", height: "100%" }}>
          <a className="close" onClick={() => handleCloseModal()}>
            &times;
          </a>

          <div className="row">
            <div className="col-sm-5"></div>
            {view ? null : (
              <div className="col-sm-4 fontWeight-bold text-blue">
                Projects Setup
              </div>
            )}
          </div>
          <div className="container-fluid">
            <div className="col-sm-12">
              <div className="ibox-content">
                <br />

                {view ? (
                  <div>
                    <h3> Projects Setup</h3>
                    <table className="table table-sm">
                      <tbody>
                        <tr>
                          <td className="font-weight-bold">Organization:</td>
                          <td>
                            {inputs.organization
                              ? inputs.organization.name
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Health:</td>
                          <td>
                            {inputs.health ? inputs.health.meaning : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Objective:</td>
                          <td>
                            {inputs.objective ? inputs.objective.title : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Title:</td>
                          <td>{inputs.title}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">
                            Budget Allocation:
                          </td>
                          <td>{inputs.budgetAllocation}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Start Date:</td>
                          <td>{inputs.startDate}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">End Date:</td>
                          <td>{inputs.endDate}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">
                            Budget Allocation:
                          </td>
                          <td>{inputs.budgetAllocation}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Status:</td>
                          <td>{inputs.status}</td>
                        </tr>
                      </tbody>
                    </table>
                    <br />
                    <div className="row">
                      <div class="d-flex flex-row ">
                        <button
                          className="btn btn-primary p-2"
                          type="button"
                          onClick={handleEdit}
                        >
                          Update
                        </button>
                        &nbsp;
                        <button
                          onClick={HandelDelete}
                          className="btn btn-danger p-2"
                        >
                          Delete
                        </button>
                        &nbsp;
                        <button
                          className="btn btn-warning p-2"
                          type="button"
                          onClick={handleCloseModal}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                    <br />
                  </div>
                ) : (
                  <form className="form-horizontal" onSubmit={HandleSubmit}>
                    <div className=" row">
                      <div className="col-sm">
                        <div className="form-group">
                          <label
                            htmlFor="Datereceived"
                            className="fontWeight-bold"
                          >
                            Organization
                          </label>
                          <select
                            className="form-control"
                            name="orgId"
                            required
                            value={inputs.orgId || ""}
                            onChange={handleInputChange}
                          >
                            <option value="">Select Organization</option>
                            {organizationOptions &&
                              organizationOptions.map((types) => (
                                <option key={types.orgId} value={types.orgId}>
                                  {types.name}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className=" row">
                      <div className="col-sm">
                        <div className="form-group">
                          <label
                            htmlFor="Datereceived"
                            className="fontWeight-bold"
                          >
                            Objective
                          </label>
                          <select
                            className="form-control"
                            name="objId"
                            required
                            value={inputs.objId || ""}
                            onChange={handleInputChange}
                          >
                            <option value="">Select Objective</option>
                            {objectiveOptions &&
                              objectiveOptions.map((types) => (
                                <option key={types.id} value={types.id}>
                                  {types.title}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className=" row">
                      <div className="col-sm">
                        <div className="form-group">
                          <label htmlFor="title" className="fontWeight-bold">
                            Title
                          </label>
                          <textarea
                            type="text"
                            className="form-control"
                            name="title"
                            required
                            value={inputs.title}
                            onChange={handleInputChange}
                            // defaultvalue={inputs.name}
                          />
                        </div>
                      </div>
                    </div>

                    <div className=" row">
                      <div className="col-sm">
                        <div className="form-group">
                          <label
                            htmlFor="startDate"
                            className="fontWeight-bold"
                          >
                            Start Date
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            name="startDate"
                            required
                            value={inputs.startDate}
                            onChange={handleInputChange}
                            // defaultvalue={inputs.name}
                          />
                        </div>
                      </div>
                      <div className="col-sm">
                        <div className="form-group">
                          <label htmlFor="endDate" className="fontWeight-bold">
                            End Date
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            name="endDate"
                            required
                            value={inputs.endDate}
                            onChange={handleInputChange}
                            // defaultvalue={inputs.name}
                          />
                        </div>
                      </div>
                    </div>

                    <div className=" row">
                      <div className="col-sm">
                        <div className="form-group">
                          <label
                            htmlFor="Datereceived"
                            className="fontWeight-bold"
                          >
                            Budget Allocation
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="budgetAllocation"
                            required
                            value={inputs.budgetAllocation}
                            onChange={handleInputChange}
                            // defaultvalue={inputs.name}
                          />
                        </div>
                      </div>
                      <div className="col-sm">
                        <div className="form-group">
                          <label
                            htmlFor="Datereceived"
                            className="fontWeight-bold"
                          >
                            Status
                          </label>
                          <select
                            className="form-control"
                            name="status"
                            required
                            value={inputs.status || ""}
                            onChange={handleInputChange}
                          >
                            <option value="">Select status</option>
                            {statusOptions &&
                              statusOptions.map((types) => (
                                <option key={types.name} value={types.name}>
                                  {types.name}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className=" row">
                      <div className="col-sm">
                        <div className="form-group">
                          <label
                            htmlFor="Datereceived"
                            className="fontWeight-bold"
                          >
                            Health
                          </label>
                          <select
                            className="form-control"
                            name="healthId"
                            required
                            value={inputs.healthId || ""}
                            onChange={handleInputChange}
                          >
                            <option value="">Select health</option>
                            {healthOptions &&
                              healthOptions.map((types) => (
                                <option
                                  key={types.healthId}
                                  value={types.healthId}
                                >
                                  {types.meaning}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm">
                        <div className="row">
                          <div className="col-sm-12">
                            <div class="d-flex flex-row">
                              {update ? (
                                <button
                                  className="btn btn-primary p-2"
                                  type="submit"
                                >
                                  Update
                                </button>
                              ) : (
                                <button
                                  className="btn btn-primary p-2"
                                  type="submit"
                                >
                                  Submit
                                </button>
                              )}
                              &nbsp;
                              <button
                                className="btn btn-warning p-2"
                                type="button"
                                onClick={handleCloseModal}
                              >
                                Close
                              </button>
                            </div>
                            <br />
                          </div>
                        </div>
                        <br />
                      </div>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};
export default ProjectsActivities;
